import {makeApiCall} from '../core';
import {DailySalesSummary, DashboardStats, ItemEnvelope} from '@ruta/shared';

/**
 * Get dashboard statistics
 */
export async function getDashboardStats(): Promise<DashboardStats> {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const response = await makeApiCall<ItemEnvelope<DashboardStats>>(
    'GET',
    `/dashboard/stats?timezone=${encodeURIComponent(tz)}`,
  );
  return response.data;
}

/**
 * Get the Today's Sales drill-down — every sales-contributing visit for the
 * day plus totals. Sends the viewer's local day and timezone so the boundary
 * matches the operator's actual "today" (not the server's UTC day). Pass an
 * explicit `date` (YYYY-MM-DD) to report on a specific day instead.
 */
export async function getDailySalesReport(date?: string): Promise<DailySalesSummary> {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // en-CA formats as YYYY-MM-DD; without an explicit date this is the viewer's
  // local day, keeping the drill-down aligned with the dashboard's Today figure.
  const day = date ?? new Date().toLocaleDateString('en-CA');
  const response = await makeApiCall<ItemEnvelope<DailySalesSummary>>(
    'GET',
    `/reports/daily-sales?date=${encodeURIComponent(day)}&timezone=${encodeURIComponent(tz)}`,
  );
  return response.data;
}
